module.exports = __webpack_public_path__ + "media/images/icon/warning-7a3f95cec4b5847d44d1e08576dc921b.svg";